import { Route, Routes } from "react-router-dom";
import BlogPage from './BlogPage';
import BlogMarkdownViewer from "./BlogMarkdownViewer";


const BlogRoutes = () => {
  return (
      <Routes>
        <Route path="/" element={<BlogPage />} />
        <Route path="/:slug" element={<BlogMarkdownViewer />} />
      </Routes>
  );
};

export default BlogRoutes;